import { render, staticRenderFns } from "./BizBusinessinfoProjectList.vue?vue&type=template&id=d842391c&scoped=true&"
import script from "./BizBusinessinfoProjectList.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoProjectList.vue?vue&type=script&lang=js&"
import style0 from "./BizBusinessinfoProjectList.vue?vue&type=style&index=0&id=d842391c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d842391c",
  null
  
)

export default component.exports